export default {
  placeholder: 'Select an event',
};
